/**
 * Company-wide content that appears in more than one place.
 *
 * A note on claims: nothing here asserts a customer, partner or integration
 * by name, and there are no performance metrics. See `docs/content-policy.md`
 * for why, and what needs sign-off before it can change.
 */
export const SITE = {
  name: 'Humrah',
  company: 'HUMRAH TECH (PRIVATE) LIMITED',
  tagline: 'Every invoice, a real shopkeeper',
  displayLine: 'A real shopkeeper',
  description:
    'Humrah ties every invoice to a store owner whose identity has been checked against the national register — so your sales data describes real deliveries, and the incentives you fund reach the right counter.',
  shortDescription:
    'Identity verification, invoice validation and direct incentive settlement for Pakistan FMCG.',
  email: 'info@humrah.com.pk',
  /* Spaced for reading; every `tel:` link strips the spaces back out. */
  phone: '+92 308 222 0827',
  address: {
    line1: 'Office 116, National Aerospace Science and Technology Park (NASTP)',
    line2: 'Shahra-e-Faisal, Karachi East',
    city: 'Karachi',
    country: 'Pakistan',
  },
} as const;
